import React from 'react';
import { DataOverview } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { Identification } from 'cpie-common';
import { DefinitionList, DefinitionListItem, Notification, NotificationStatus } from '@cp-shared-15/frontend-ui';

export const IdentificationSection: React.FC<{ identification: Identification }> = ({ identification }) => {
    const { t } = useTranslation('my-profile');

    if (!identification.id) {
        return (
            <Notification status={NotificationStatus.error} headline={t('identification.business-error.title')}>
                {t('identification.business-error.text')}
            </Notification>
        );
    }

    const identificationList: DefinitionListItem[] = [
        {
            label: t('identification.items.label.name'),
            value: identification.name,
            testId: 'identification-email',
        },
    ];

    return (
        <DataOverview titleLevel={3} title={t('identification.title')}>
            <DefinitionList split={true} list={identificationList} />
        </DataOverview>
    );
};
